/* eslint-disable react/prop-types */
import { useNavigate } from 'react-router-dom';

import './GenericButton.css';

const GenericButton = ({ className = '', page = '', text = '' }) => {
  const navigate = useNavigate();

  const handleStart = () => {
    if (page.startsWith('http://') || page.startsWith('https://')) {
      window.open(page, '_blank');
    } else {
      navigate(page);
    }
  };

  return (
    <button className={`generic-button ${className}`} onClick={handleStart}>
      <span>{text}</span>
    </button>
  );
};

export default GenericButton;
